<div *ngIf="qrCode">
  <h3>Scan the QR code in the authenticator app</h3>
  <img [src]="qrCode" alt="QR код">

  <div>
    <p>Enter a one-time password</p>
    <mat-form-field appearance="outline" class="w100 mt16">
      <input matInput
             type="text"
             [(ngModel)]="token"
             placeholder="Enter a one-time password">
    </mat-form-field>

    <button mat-raised-button color="primary"
            (click)="onVerify()">Confirm</button>
  </div>
</div>

<div *ngIf="secretEnabled">
  <div>
    <p>Enter a one-time password</p>
    <mat-form-field appearance="outline" class="w100 mt16">
      <input matInput
             type="text"
             [(ngModel)]="token"
             placeholder="Enter a one-time password">
    </mat-form-field>

    <button mat-raised-button color="primary" (click)="onVerify()">Confirm</button>
  </div>
</div>

<div *ngIf="verificationResult !== null">
  <ng-container *ngIf="verificationResult; else errorMsg"></ng-container>

  <ng-template #errorMsg>
    <p>Invalid token, try again.</p>
  </ng-template>
</div>
